// extracted by mini-css-extract-plugin
module.exports = {"sectionWrapper":"k9","header":"k-"};